// apps/web/src/features/dashboards/china-requests/section.ts (#1589)
// Shared prop types + tokens for the dashboard section components.
import type { CSSProperties } from 'react';
import type { useTranslation } from 'react-i18next';
import type { useLocale } from '../../../i18n/useLocale.js';

// The page resolves these three namespaces once and threads `t` down so
// every section reuses the same status/reason copy.
export type DashboardT = ReturnType<
  typeof useTranslation<['dashboards', 'requests', 'common']>
>['t'];

export type AppLocale = ReturnType<typeof useLocale>['locale'];

export const SECTION_CARD: CSSProperties = {
  background: 'var(--bg-1)',
  border: '1px solid var(--border-1)',
  borderRadius: 'var(--r-2)',
  padding: 12,
};

export const SECTION_GAP = 16;
export const CARD_GAP = 12;
